import type { ComponentType } from "react";
import useUser from "features/auth/useUser";
import When from "ui/support/When";
import NotAuthorized from "ui/molecules/NotAuthorized";
import type { AuthorizedProps } from "./types";

export const withAuthorization = <TProps extends Partial<AuthorizedProps>>(
    Component: ComponentType<TProps>,
    options?: AuthorizedProps
) => (props: TProps) => {
    const { hasRole } = useUser();

    const {
        roles = [],
        fallback = (
            <NotAuthorized />
        )
    } = {
        ...options,
        ...props,
    };

    return (
        <When
            if={!roles.length || hasRole(roles)}
            then={(
                <Component
                    {...props}
                />
            )}
        >
            {fallback}
        </When>
    );
};

export default withAuthorization;
